// Copyright (c) Docugami, Inc. All rights reserved.**/

import styled from "styled-components";

export type PropsWithChildrenAndClassName<P> = React.PropsWithChildren<P> & {
    className?: string;
}

interface LayoutProps {
    numOfColumns?: number;
    numOfRows?: number;
    gap?: number;
    xsNumOfColumns?: number;
    xsNumOfRows?: number;
    xsGap?: number;
    smNumOfColumns?: number;
    smNumOfRows?: number;
    smGap?: number;
    mdNumOfColumns?: number;
    mdNumOfRows?: number;
    mdGap?: number;
    lgNumOfColumns?: number;
    lgNumOfRows?: number;
    lgGap?: number;
    xlNumOfColumns?: number;
    xlNumOfRows?: number;
    xlGap?: number;
    className?: string;
}

const numberToPixels = (num: number)=>{
    return `${num}px`
}

export const xsScreenMinWidth = numberToPixels(0);
export const smScreenMinWidth = numberToPixels(600);
export const mdScreenMinWidth = numberToPixels(960);
export const lgScreenMinWidth = numberToPixels(1280);
export const xlScreenMinWidth = numberToPixels(1920);

const Container = styled.div<LayoutProps>`
    --num-of-columns: ${props => props.numOfColumns || 12};
    --num-of-rows: ${props => props.numOfRows || 12};
    display: grid;
    height: 100%;
    width: 100%;
    @media only screen and (min-width: ${xsScreenMinWidth}) {
        ${props => !!props.xsNumOfColumns ? `grid-template-columns: repeat(${props.xsNumOfColumns}, 1fr);` : 'grid-template-columns: repeat(var(--num-of-columns), 1fr);'}
        ${props => !!props.xsNumOfRows ? `grid-template-rows: repeat(${props.xsNumOfRows}, 1fr);` : 'grid-template-rows: repeat(var(--num-of-rows), 1fr);'}
        ${props => !!props.xsGap ? `gap: ${numberToPixels(props.xsGap)};` : (!!props.gap ? `gap: ${numberToPixels(props.gap)};` : '')}
    }
    @media only screen and (min-width: ${smScreenMinWidth}) {
        ${props => !!props.smNumOfColumns ? `grid-template-columns: repeat(${props.smNumOfColumns}, 1fr);` : ''}
        ${props => !!props.smNumOfRows ? `grid-template-rows: repeat(${props.smNumOfRows}, 1fr);` : ''}
        ${props => !!props.smGap ? `gap: ${numberToPixels(props.smGap)};` : ''}
    }
    @media only screen and (min-width: ${mdScreenMinWidth}) {
        ${props => !!props.mdNumOfColumns ? `grid-template-columns: repeat(${props.mdNumOfColumns}, 1fr);` : ''}
        ${props => !!props.mdNumOfRows ? `grid-template-rows: repeat(${props.mdNumOfRows}, 1fr);` : ''}
        ${props => !!props.mdGap ? `gap: ${numberToPixels(props.mdGap)};` : ''}
    }
    @media only screen and (min-width: ${lgScreenMinWidth}) {
        ${props => !!props.lgNumOfColumns ? `grid-template-columns: repeat(${props.lgNumOfColumns}, 1fr);` : ''}
        ${props => !!props.lgNumOfRows ? `grid-template-rows: repeat(${props.lgNumOfRows}, 1fr);` : ''}
        ${props => !!props.lgGap ? `gap: ${numberToPixels(props.lgGap)};` : ''}
    }
    @media only screen and (min-width: ${xlScreenMinWidth}) {
        ${props => !!props.xlNumOfColumns ? `grid-template-columns: repeat(${props.xlNumOfColumns}, 1fr);` : ''}
        ${props => !!props.xlNumOfRows ? `grid-template-rows: repeat(${props.xlNumOfRows}, 1fr);` : ''}
        ${props => !!props.xlGap ? `gap: ${numberToPixels(props.xlGap)};` : ''}
    }
`;

export interface GridContainerProps extends PropsWithChildrenAndClassName<LayoutProps> { }

export const GridContainer = (props: React.PropsWithChildren<GridContainerProps>) => (
    <Container
        {...props}
    />
)
